import { Backend } from "./backend";
import { ApiBackend } from "./api-backend";

export const api: Backend = new ApiBackend();
